

@if (showPopup) {
  <div class="popup-box">
    <div class="in-box">
      <button type="button" class="leave-button" (click)="showPopup = false"></button>
      @if (popupData.type == 1) {
        <div id="contentToConvert" class="cert">
          <img src="/assets/images/awards/cert.jpg">
          <div class="cert-text">
            <div class="name">{{userInfo.name}}</div>
            <div class="description">
              for completing {{popupData.quizName}} in <br>the continent of {{popupData.continentName}}
              <!-- for achieving 100% in the<br>continent of -->
            </div>
            <div class="date">{{popupData.date}}</div>
          </div>
        </div>
      }
      @if (popupData.type == 2) {
        <div id="contentToConvert" class="cert2">
          <img src="/assets/images/awards/{{popupData.certName}}">
          <div class="cert-text">
            <div class="name">{{userInfo.name}}</div>
            <!-- <div class="school">{{userInfo.school}}</div> -->
            <div class="date">{{popupData.date}}</div>
          </div>
        </div>
      }
      <button type="button" class="download-button" (click)="captureScreen()"></button>
    </div>
  </div>
}




<div class="frame-in">
  <div [ngClass]="{'hidden': loading}">
    @if (userInfo) {
      <div class="awards">
        <button type="button" class="leave-button" (click)="previousState()"></button>
        <div class="points">
          <div class="bronze">{{scores.bronze}}</div>
          <div class="silver">{{scores.silver}}</div>
          <div class="gold">{{scores.gold}}</div>
        </div>
        <button type="button" class="slider-back" (click)="previous()"></button>
        <button type="button" class="slider-next" (click)="next()"></button>
        <div class="slider-titles">
          @if (activeWindow == 1) {
            <div class="title">Asia & Oceania</div>
          }
          @if (activeWindow == 2) {
            <div class="title">Europe</div>
          }
          @if (activeWindow == 3) {
            <div class="title">Africa</div>
          }
          @if (activeWindow == 4) {
            <div class="title">South America</div>
          }
          @if (activeWindow == 5) {
            <div class="title">North America</div>
          }
        </div>
        <div class="slider-box">
          @if (activeWindow == 1) {
            <div class="item">
              @for (item of asiaCerts; track item) {
                <div class="sert" (click)="openPopup(1,'Asia and Oceania', item.date, item.quizName, 'Empty')">
                  <img src="/assets/images/awards/cert-200.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                    <div class="description">
                      for completing {{item.quizName}} in <br>the continent of Asia & Oceania
                    </div>
                    <div class="date">{{item.date}}</div>
                  </div>
                </div>
              }
              @if (continentCerts.length > 0) {
                <div class="sert final" (click)="openPopup(2,'Asia and Oceania', continentCerts[0].date, 'Level complete', 'cert-asia.jpg')">
                  <img src="/assets/images/awards/cert-asia.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (activeWindow == 2) {
            <div class="item">
              @for (item of europeCerts; track item) {
                <div class="sert" (click)="openPopup(1,'Europe', item.date, item.quizName, 'Empty')">
                  <img src="/assets/images/awards/cert-200.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                    <div class="description">
                      for completing {{item.quizName}} in <br>the continent of Europe
                    </div>
                    <div class="date">{{item.date}}</div>
                  </div>
                </div>
              }
              @if (continentCerts.length > 1) {
                <div class="sert final" (click)="openPopup(2,'Asia and Oceania', continentCerts[1].date, 'Level complete', 'cert-europe.jpg')">
                  <img src="/assets/images/awards/cert-europe.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (activeWindow == 3) {
            <div class="item">
              @for (item of africaCerts; track item) {
                <div class="sert" (click)="openPopup(1,'Africa', item.date, item.quizName, 'Empty')">
                  <img src="/assets/images/awards/cert-200.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                    <div class="description">
                      for completing {{item.quizName}} in <br>the continent of Africa
                    </div>
                    <div class="date">{{item.date}}</div>
                  </div>
                </div>
              }
              @if (continentCerts.length > 2) {
                <div class="sert final" (click)="openPopup(2,'Africa and Oceania', continentCerts[2].date, 'Level complete', 'cert-africa.jpg')">
                  <img src="/assets/images/awards/cert-africa.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (activeWindow == 4) {
            <div class="item">
              @for (item of americaCerts; track item) {
                <div class="sert" (click)="openPopup(1,'South America', item.date, item.quizName, 'Empty')">
                  <img src="/assets/images/awards/cert-200.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                    <div class="description">
                      for completing {{item.quizName}} in <br>the continent of South America
                    </div>
                    <div class="date">{{item.date}}</div>
                  </div>
                </div>
              }
              @if (continentCerts.length > 3) {
                <div class="sert final" (click)="openPopup(2,'South America', continentCerts[3].date, 'Level complete', 'cert-africa.jpg')">
                  <img src="/assets/images/awards/cert-africa.jpg">
                  <div class="cert-text">
                    <div class="name">{{userInfo.name}}</div>
                  </div>
                </div>
              }
            </div>
          }
          @if (activeWindow == 5) {
            <div class="item">
            </div>
          }
        </div>
      </div>
    }
    <img class="frame-bg" src="assets/images/awards/bg.jpg" (loadeddata)="instructionLoaded()">
  </div>
</div>
